import { ProjectStatusEnum } from "@nlc/shared-types";

export function isPausePlan(accountType: null | string): boolean {
  return accountType === ProjectStatusEnum.PAUSED;
}
